import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import http from 'http'

import Redirect from 'components/Redirect'
import Profile from 'context/Profile'
import Theme from 'components/Theme'

const Guard = () => {
  const navigate = useNavigate()

  useEffect( () => {
    http
      .get( '/auth/ping' )
      .catch( err => {
        navigate( '/auth/login' )
      } )
  }, [] )

  const token = localStorage.getItem( 'token' )

  if ( ! token )
    return <Redirect to="/auth/login" />

  return <Profile>
    <Theme>
      <Outlet />
    </Theme>
  </Profile>
}

export default Guard
